<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title" :className="pageType" :noCloseOnEsc="true")
    b-container(fluid)
      .context
        b-form
          template(v-if="!limitCount")
            h3.title {{$t('applicant')}}
            .form-wrap
              b-form-group(
                content-cols-sm
                :label="$t('ID')"
                label-for="id"
                label-cols-sm="2"
                label-align-sm="left"
              )
                b-form-input#id(v-model="form.user_id" size="sm" style="width: 430px" readonly)
              
              b-form-group(
                content-cols-sm
                :label="$t('name')"
                label-for="name"
                label-cols-sm="2"
                label-align-sm="left"
              )
                b-form-input#name(v-model="form.user_name" size="sm" style="width: 430px" readonly)
              
              b-form-group(
                content-cols-sm
                :label="$t('department')"
                label-for="department"
                label-cols-sm="2"
                label-align-sm="left"
              )
                b-form-input#department(v-model="form.user_part" size="sm" style="width: 430px" readonly)
              
              b-form-group(
                content-cols-sm
                :label="$t('approval_line')"
                label-for="approver"
                label-cols-sm="2"
                label-align-sm="left"
              )
                .d-flex.align-items-center
                  b-form-input#approver(v-model="form.approver" size="sm" style="width: 430px" readonly)
                  b-btn.ml-2(size="sm" @click="openDialogApprovalLine") {{$t('selection')}}
              
              b-form-group(
                content-cols-sm
                :label="$t('application_datetime')"
                label-for="regDate"
                label-cols-sm="2"
                label-align-sm="left"
              )
                b-form-input#regDate(v-model="form.create_time" size="sm" style="width: 430px" readonly)

            h3.title {{$t('dialogs_page.application_info')}}
            .form-wrap
            b-form-group(
              content-cols-sm
              :label="$t('manager_name')"
              label-for="managerName"
              label-cols-sm="2"
              label-align-sm="left"
            )
              b-form-input#managerName(v-model="form.manager_name" size="sm" style="width: 430px")
            
            b-form-group(
              content-cols-sm
              label="OS"
              label-for="os"
              label-cols-sm="2"
              label-align-sm="left"
            )
              b-form-input#os(v-model="form.os" size="sm" style="width: 430px" readonly)
            
            b-form-group(
              content-cols-sm
              label="IP"
              label-for="ip"
              label-cols-sm="2"
              label-align-sm="left"
            )
              b-form-input#ip(v-model="form.ip" size="sm" style="width: 430px" readonly)
          
          h3.title {{$t('dialogs_page.registered_manager_info')}}
          .form-wrap.columns.mb-2
            label.d-flex.align-items-center
              span {{$t('dialogs_page.max_registration_allowed')}}
              b-form-input#max(v-model="form.max_device" size="sm" style="width: 50px" readonly)
            label.d-flex.align-items-center
              span {{$t('dialogs_page.current_registration')}}
              b-form-input#max(v-model="form.current_device" size="sm" style="width: 50px" readonly)
            label.d-flex.align-items-center
              span {{$t('dialogs_page.registration_in_progress')}}
              b-form-input#max(v-model="form.waiting_device" size="sm" style="width: 50px" readonly)
              em + 1

          b-table.type-2.mb-3(
            v-if="userFk !== null"
            ref="table"
            :fields="tableData.fields"
            :items="fetchList"
            :empty-text="$t('no_data_available')"
            show-empty
            responsive
          )
            template(v-slot:cell(create_time)="row")
              span {{ row.item.create_time | moment('YY-MM-DD HH:mm') }}
            
            template(v-slot:cell(last_login_time)="row")
              span {{ row.item.last_login_time | moment('YY-MM-DD HH:mm') }}

            template(v-slot:cell(delete)="row")
              b-link(size="sm" @click="selectDelete([row.item])") #[span.svg-icon.trash delete]

        .warning.limit(v-if="limitCount")
          icon.icon(name="exclamation-triangle" width="50" height="50")
          p {{$t('dialogs_page.manager_registration_limit_exceeded')}}
          p(v-html="$t('dialogs_page.remove_or_revoke_pending_manager_requests')")
    .modal-footer(v-if="!limitCount")
      b-button(size="sm" variant="primary" @click="submit" :disabled="loadingSubmit" pill) {{$t('registration')}}
      b-button(variant="secondary" size="sm" @click="close" pill) {{$t('cancel')}}
    .modal-footer(v-else)
      b-button(variant="secondary" size="sm" @click="close" pill) {{$t('submit')}}

    dialog-approval-line(
      :show.sync="showDialogApprovalLine"
      :userId="form.user_id"
      :limit="form.approve_seq"
      @submit="submitApprovalLine"
    )

    confirm-dialogs(:show.sync="showManagerDelete" :option="{ size: 'md', title: this.$t('delete_registered_manager') }")
      .warning
        icon.icon(name="exclamation-triangle" width="50" height="50")
        span ※ Warning ※
      .box
        .msg {{$t('confirm_delete_registered_manager')}}
        .selectselectApprover
          span(v-for="item of deleteList" :key="item.pk") "{{$t('manager') }}({{ item.device_name }})"
        .msg(v-html="$t('re_register_manager_approval_required')")
      .bottom-btns
        b-btn(size="sm" variant="danger" @click="deleteManager" pill) {{$t('delete')}}
        b-btn(size="sm" @click="showManagerDelete = false" pill) {{$t('cancel')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import DialogApprovalLine from "./dialogApprovalLine"
import moment from "moment"
import _ from "lodash"

import { ApprovalAPI, UserEntityRegisterNotTokenAPI } from "@/api"

const defaultForm = {
  user_id: "",
  user_name: "",
  user_part: "",
  os: "",
  ip: "",
  max_device: 100,
  current_device: "",
  waiting_device: "",

  create_time: moment().format("YY-MM-DD HH:mm"),
  manager_name: "",

  approver: "",
  approvel: "",

  manager_fk: "",
  manager_device_fk: "",
}

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialogs,
    DialogApprovalLine,
    ConfirmDialogs,
  },
  computed: {
    limitCount() {
      return this.form.max_device <= this.form.current_device + this.form.waiting_device
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.visible = newVal
      },
      immediate: true,
    },
    visible(newVal) {
      if (newVal) {
        this.form = _.cloneDeep(defaultForm)
        this.form.user_id = this.$route.query.userId
        this.form.manager_device_fk = this.$route.query.managerDeviceFk
        this.fetchData()
      }
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      title: this.$t('dialogs_page.manager_registration_request'),
      visible: false,
      showDialogApprovalLine: false,
      showManagerDelete: false,
      loadingSubmit: false,
      form: _.cloneDeep(defaultForm),
      pageType: "type-layer",
      userFk: null,

      approvalLineData: [
        {
          userId: "",
          mgrid: "",
          apInfId: "",
          opinion: "",
          seq: 0,
          type: 0,
          type_pk: 1, // 이건?
        },
      ],

      tableData: {
        fields: [
          { key: "device_name", label: this.$t('manager_name'), thStyle: { minWidth: "130px" } },
          { key: "manager_os", label: "OS", thStyle: { minWidth: "100px" } },
          { key: "create_time", label: this.$t('registration_datetime'), thStyle: { minWidth: "130px" } },
          { key: "last_login_time", label: this.$t('last_login_datetime'), thStyle: { minWidth: "130px" } },
          { key: "delete", label: this.$t('delete'), thClass: "text-center", thStyle: { minWidth: "80px" } },
        ],
      },

      deleteList: [],
    }
  },
  mounted() {
    if (this.$route.name === "popup-manager") {
      this.$nextTick(() => {
        this.pageType = "type-popup"
        this.visible = true
      })
    }
  },
  methods: {
    fetchData() {
      // @@@ manager_fk값은 알 수 없으므로, 사용자가 입력했던 user_id를 이용하여 user를 식별
      // device_fk는 사실상 temp 관련 테이블의 pk이다.
      if (this.form.user_id === undefined) return
      ApprovalAPI.approvalManager.get("", { params: { user_id: this.form.user_id, manager_device_fk: this.form.manager_device_fk } }).then(res => {
        const { user_fk, user_id, user_name, user_part, os, ip, max_device, current_device, waiting_device, device_name, approve_seq } = res.data.objects
        const osPrint = {
          0: "UNKNOWN",
          1: "Windows",
          2: "Linux",
          3: "OS_X",
          4: "Android",
          5: "iOS",
        }[os]

        this.form.user_id = user_id
        this.form.user_name = user_name
        this.form.user_part = user_part
        this.form.os = osPrint
        this.form.ip = ip
        this.form.max_device = max_device
        this.form.current_device = current_device
        this.form.waiting_device = waiting_device
        this.form.manager_name = device_name
        this.form.approve_seq = approve_seq

        this.userFk = user_fk

        this.title = this.$t('dialogs_page.manager_registration_request')
        if (this.limitCount) {
          this.title = this.$t('dialogs_page.manager_registration_request_exceeded')
        }

        this.approvalLineData = []
        this.approvalLineData.push({
          userId: "",
          mgrid: user_id,
          apInfId: "",
          opinion: "",
          seq: 0,
          type: 0,
          type_pk: 1, // 이건?
        })
      })
    },
    submitApprovalLine(form) {
      const id = []
      const pk = []
      const name = []
      const print = []
      for (const [index, item] of Object.values(form).entries()) {
        if (item.name) {
          id.push(item.id)
          pk.push(item.pk)
          name.push(item.name)
          print.push(item.print)

          // 결재 라인
          const check = _.find(this.approvalLineData, { seq: index + 1 })
          if (check) {
            check.mgrid = item.id
          } else {
            this.approvalLineData.push({
              userId: "",
              mgrid: item.id,
              apInfId: "",
              opinion: "",
              seq: index + 1,
              type: 0,
              type_pk: 1, // 이건?
            })
          }
        }
      }

      this.form.approver = print.join(", ")
      this.form.approvel = pk.join(",")
    },
    fetchList() {
      return UserEntityRegisterNotTokenAPI.get(String(this.userFk), { params: { input_type: "manager" } }).then(res => {
        const { objects } = res.data
        this.tableData.list = objects
        return this.tableData.list
      })
    },
    selectDelete(items) {
      this.deleteList = _.cloneDeep(items)
      this.showManagerDelete = true
    },
    openDialogApprovalLine() {
      this.showDialogApprovalLine = true
    },
    normalize() {
      return {
        user_id: this.form.user_id,
        manager_device_fk: this.form.manager_device_fk,
        approval: this.form.approvel,
        create_time: this.form.create_time,
        manager_name: this.form.manager_name,
        reason: "",
        react_reason: "",
      }
    },
    submit() {
      if (_.isEmpty(this.form.approver)) {
        this.AppState.$emit("show-message-dialog", { context: { path: this.$t('dialogs_page.select_approval_line') } })
        return
      }
      if (_.isEmpty(this.form.manager_name)) {
        this.AppState.$emit("show-message-dialog", { context: { path: this.$t('dialogs_page.enter_manager_name') } })
        return
      }
      this.loadingSubmit = true
      ApprovalAPI.approvalManager
        .post("", this.normalize())
        .then(res => {
          this.visible = false
          if (this.$route.name === "popup-manager") {
            this.$nextTick(() => {
              alert(this.$t('dialogs_page.manager_registration_completed'))
              window.close()
            })
          }
          this.loadingSubmit = false
        })
        .catch(err => {
          console.log(err)
          this.loadingSubmit = false
        })
    },
    close() {
      if (this.$route.name === "popup-manager") {
        window.close()
        return
      }
      this.visible = false
    },
    deleteManager() {
      const data = {
        input_type: "manager",
        device_id: this.deleteList[0].device_id,
        pk: this.deleteList[0].pk,
      }
      UserEntityRegisterNotTokenAPI.delete(String(this.userFk), { data }).then(res => {
        this.showManagerDelete = false
        this.$refs.table.refresh()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #000000;
  background-color: #f5f5f5;
  line-height: 41px;
  padding-left: 2px;
  margin-bottom: 20px;
  &::before {
    content: "";
    display: inline-block;
    margin: 0 8px;
    width: 1px;
    height: 21px;
    background-color: #000000;
  }
}
.form-wrap {
  padding-bottom: 10px;

  &.columns {
    display: flex;
    align-items: center;
    label {
      position: relative;
      padding-left: 8px;
      font-size: 15px;
      color: #000000;
      font-weight: 500;
      margin: 0 15px;
      span {
        padding-right: 10px;
      }
      em {
        font-style: normal;
        padding-left: 8px;
        animation: blink 1s infinite;
      }
    }
  }
}

.context > .warning {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  padding: 20px 0 0;
  &.limit {
    svg {
      margin-bottom: 15px;
    }
  }
  i {
    color: #c8c8c8;
    margin-bottom: 20px;
  }
}

@keyframes blink {
  0%,
  100% {
    color: black;
  }
  50% {
    color: red;
  }
}
::v-deep {
  .form-row.form-group {
    margin-bottom: 3px;
    margin-left: 12px;
    > label {
      &::after {
        display: none;
      }
    }
  }
  .delete svg {
    color: #b1b1b1;
  }
}
</style>
